var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 6.375C12.5269 6.375 10.625 8.27688 10.625 10.625V40.375C10.625 42.7231 12.5269 44.625 14.875 44.625H36.125C38.4731 44.625 40.375 42.7231 40.375 40.375V10.625C40.375 8.27688 38.4731 6.375 36.125 6.375H14.875ZM14.875 10.625H36.125V40.375H14.875V10.625ZM2.125 12.75V38.25H6.375V12.75H2.125ZM44.625 12.75V38.25H48.875V12.75H44.625ZM25.5 17C23.1519 17 21.25 18.9019 21.25 21.25C21.25 23.5981 23.1519 25.5 25.5 25.5C27.8481 25.5 29.75 23.5981 29.75 21.25C29.75 18.9019 27.8481 17 25.5 17ZM25.5 29.75C22.6631 29.75 17 31.1737 17 34V36.125H34V34C34 31.1737 28.3369 29.75 25.5 29.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualBackground);
export default __webpack_public_path__ + "static/media/virtual-background.e623bbb82d4dd88ca12e35bdd3f278d1.svg";
export { ForwardRef as ReactComponent };